import Avatar from '@components/v2/ui/Avatar/Avatar';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { SignatureInfo } from '../../lib/SiteLib';
import useTeceoStyles from '../../useTeceoStyles';
import { formatGlobalCellphone } from '../../utils/formatters';
import useWidth from '../Hooks/useWidth';

const AVATAR_SIZE = 96;

export type PersonSignatureProps = {} & SignatureInfo;

const PersonSignature = ({
  name,
  role,
  email,
  phone,
  avatar,
  countryCode,
}: PersonSignatureProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { mobileWidth } = useWidth();
  const textAlign = mobileWidth ? 'center' : 'left';

  return (
    <Grid
      container
      spacing={2}
      wrap={mobileWidth ? 'wrap' : 'nowrap'}
      sx={{
        justifyContent: mobileWidth ? 'center' : 'flex-start',
        alignItems: 'center',
      }}
    >
      <Grid size="auto">
        <Avatar size={AVATAR_SIZE} src={avatar || ''} alt={name || ''} initials={name?.charAt(0)} />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          md: 8,
        }}
      >
        <Typography noWrap align={textAlign}>
          <Box
            component="span"
            sx={{
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            {name}
          </Box>
        </Typography>
        <Typography noWrap align={textAlign}>
          {role}
        </Typography>

        {email && (
          <Link to={`mailto:${email}`} className={teceoClasses.linkDisguised}>
            <Typography noWrap align={textAlign}>
              {email}
            </Typography>
          </Link>
        )}
        <Typography noWrap align={textAlign}>
          {phone && countryCode ? formatGlobalCellphone(phone, countryCode) : ''}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PersonSignature;
